var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notFound"}},[_c('img',{staticClass:"notFoundImg",attrs:{"src":_vm.notFoundImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }